import axios from "../network/reuset";
import qs from "qs";

const post = (url, params) => axios.post(url, qs.stringify(params));

const getPayouts = {
  getPayoutsList(params) {
    return post(`/api/admin/payouts/list`, params);
  },
  getPayoutsInfo(params) {
    return post(`/api/admin/payouts/info`, params);
  },
  confirmPaid(params) {
    return post(`/api/admin/payouts/confirm_paid`, params);
  },
  reject(params) {
    return post(`/api/admin/payouts/reject`, params);
  },
  saveCheckPayouts(params) {
    return post(`/api/admin/payouts/check`, params);
  },
  getMoneyList(params) {
    return post(`/api/admin/payouts/amount_option/list`, params);
  },
  postSaveMoney(params) {
    return post(`/api/admin/payouts/amount_option/save`, params);
  },
  postAddMoney(params) {
    return post(`/api/admin/payouts/amount_option/add`, params);
  },
  delMoney(params) {
    return post(`/api/admin/payouts/amount_option/del`, params);
  },
  postAddPayouts() {
    return Promise.reject(new Error("当前版本不支持后台代用户新建提现单"));
  },
};

export default getPayouts;
